import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import './Login.scss';
import { useRecoilState } from 'recoil';
import { tokenState } from '../../../atoms/token';
import { useAuth } from '../../../hooks/useAuth';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();
  const [token, setToken] = useRecoilState(tokenState);

  useEffect(() => {
    const checkAuth = async () => {
      // If we're in a callback state, the auth service will handle it
      if (window.location.hash.includes('code=')) {
        return;
      }

      if (token) {
        const returnUrl = localStorage.getItem('returnUrl');
        if (returnUrl) {
          localStorage.removeItem('returnUrl');
          navigate(returnUrl);
        } else {
          navigate('/');
        }
      }
    };

    checkAuth();
  }, [token, navigate]);
 
  return (
    <div className='center-login'>
      <Button 
        id="login"
        variant="contained" 
        className="big"         
        startIcon={<FontAwesomeIcon icon={["fas", "user"]} />}
        onClick={login}>
          Login
      </Button>
    </div>
  );
};

export default Login;